import React from 'react';
import { useTheme } from '../../../context/theme';

export const Github = () => {
    const { theme } = useTheme();

    return (
        <svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7_188)">
                <path d="M17 0C7.88925 0 0.5 7.38788 0.5 16.5C0.5 23.7903 5.22725 29.975 11.7846 32.1571C12.6082 32.3098 12.875 31.7983 12.875 31.3638V28.292C8.28525 29.2903 7.32963 26.345 7.32963 26.345C6.57888 24.4379 5.49675 23.9305 5.49675 23.9305C3.99938 22.9061 5.61088 22.9281 5.61088 22.9281C7.26775 23.0436 8.1395 24.629 8.1395 24.629C9.61075 27.1508 11.9991 26.422 12.941 25.9999C13.0881 24.9343 13.5158 24.2055 13.9888 23.7944C10.3244 23.375 6.47162 21.9601 6.47162 15.6393C6.47162 13.8366 7.1165 12.3654 8.17112 11.2104C8.00063 10.7938 7.4355 9.11488 8.332 6.84338C8.332 6.84338 9.718 6.40063 12.8709 8.53463C14.1867 8.16888 15.5975 7.986 17 7.97913C18.4025 7.986 19.8146 8.16888 21.1332 8.53463C24.2834 6.40063 25.6666 6.84338 25.6666 6.84338C26.5645 9.11625 25.9994 10.7951 25.8289 11.2104C26.8876 12.3654 27.527 13.838 27.527 15.6393C27.527 21.9766 23.6674 23.3723 19.9934 23.7806C20.5846 24.2921 21.125 25.2959 21.125 26.8359V31.3638C21.125 31.8024 21.389 32.318 22.2264 32.1558C28.7782 29.9709 33.5 23.7875 33.5 16.5C33.5 7.38788 26.1121 0 17 0Z" fill={theme.secondary} />
            </g>
            <defs>
                <clipPath id="clip0_7_188">
                    <rect width="33" height="33" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>

    )
}
